import { render, staticRenderFns } from "./WebCoder.vue?vue&type=template&id=52213250&scoped=true"
import script from "./WebCoder.vue?vue&type=script&lang=js"
export * from "./WebCoder.vue?vue&type=script&lang=js"
import style0 from "./WebCoder.vue?vue&type=style&index=0&id=52213250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52213250",
  null
  
)

export default component.exports